/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Tfield_Venue_UrlInputs */



/**
* | output |
* | --- |
* | "Venue URL" |
*
* @param {Tfield_Venue_UrlInputs} inputs
* @param {{ locale?: "en" | "fr" | "es" | "pt" | "it" }} options
* @returns {LocalizedString}
*/
export const tfield_venue_url = /** @type {((inputs?: Tfield_Venue_UrlInputs, options?: { locale?: "en" | "fr" | "es" | "pt" | "it" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Tfield_Venue_UrlInputs, { locale?: "en" | "fr" | "es" | "pt" | "it" }, {}>} */ ((inputs = {}, options = {}) => {
	void inputs;
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "fr") return /** @type {LocalizedString} */ ("URL du lieu")
	if (locale === "es") return /** @type {LocalizedString} */ ("URL de la sede")
	if (locale === "pt") return /** @type {LocalizedString} */ ("URL do Local")
	if (locale === "it") return /** @type {LocalizedString} */ ("URL Sede")
	return /** @type {LocalizedString} */ ("Venue URL")
});